var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.541992 2.20833C0.541992 1.1037 1.43736 0.208328 2.54199 0.208328H5.68866C6.25409 0.208328 6.80145 0.406489 7.2358 0.768347L9.06355 2.29166H15.4587C16.5633 2.29166 17.4587 3.18703 17.4587 4.29166V11.7917C17.4587 12.8963 16.5633 13.7917 15.4587 13.7917H2.54199C1.43736 13.7917 0.541992 12.8963 0.541992 11.7917V2.20833ZM7.62054 3.04166L6.27568 1.92081C6.27565 1.92078 6.27572 1.92084 6.27568 1.92081C6.11088 1.78356 5.90318 1.70833 5.68866 1.70833H2.54199C2.26579 1.70833 2.04199 1.93213 2.04199 2.20833V4.375H5.68866C5.90323 4.375 6.11087 4.29982 6.27568 4.16251L7.62054 3.04166ZM2.04199 5.875V11.7917C2.04199 12.0679 2.26579 12.2917 2.54199 12.2917H15.4587C15.7349 12.2917 15.9587 12.0679 15.9587 11.7917V4.29166C15.9587 4.01546 15.7349 3.79166 15.4587 3.79166H9.06355L7.23592 5.31488C6.80157 5.67674 6.25409 5.875 5.68866 5.875H2.04199Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.f54d9ed1e44203233767f053f21c01b8.svg";
export { ForwardRef as ReactComponent };